<template>
    <div class="app-publication-settings">

        <details class="app-accordion">
            <summary class="app-accordion__header">
                <h4 class="app-accordion__title">Project Config Settings</h4>
                <svg class="element-icon--chevron-down element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-chevron-down"></use></svg>
            </summary>
            <div class="app-accordion__body">
                <p>Define config settings, such as setting up Issue Tracker, that will be applied to all courses in this project.</p>
                <code-editor
                    ref="project-configuration"
                    :value="getJSONString(projectConfiguration)"
                    :placeholder="'{\n\t&quot;key&quot;: &quot;value&quot;\n}'"
                    language="json"
                    rows="10"
                    @change="updateProjectConfiguration($event)">
                </code-editor>
            </div>
        </details>
    </div>
</template>

<script>
import _ from 'lodash'
import api from '../api/publisher'

export default {
    props: {
        project: {
            type: Object,
        },
    },
    data() {
        return {
            projectConfiguration: this.project.configuration,
        }
    },
    methods: {
        getJSONString(obj) {
            if (!obj) {
                return ''
            }
            return JSON.stringify(obj, null, 2)
        },
        async updateProjectConfiguration($event) {
            let configuration = $event.target.value
            if (_.isString(configuration) && !configuration.length) {
                configuration = null
            } else {
                configuration = JSON.parse(configuration)
            }

            // api call to save project configuration
            const result = await api.updateProjectConfiguration(
                this.project.id,
                configuration
            )

            if (result.errors) {
                // catch errors
                console.error(result.errors)
            } else {
                // update publication
                this.project.configuration = result.configuration
            }
        }
    }
}
</script>
